<template>
	<div>
		<button v-show="!hide" :class="{ 'btn btn-primary': !buttonType, 'btn btn-primary-outline': buttonType === 'outline' }" type="button" @click="toggleModal()">
			<slot name="icon"></slot>
			<span>{{ triggerText }}</span>
		</button>

		<div v-if="showModal" class="fixed inset-0 z-50 overflow-y-auto overflow-x-hidden outline-none focus:outline-none">
			<div class="min-h-full flex justify-center items-start px-4 py-6 sm:py-10">
			<div
				class="relative mx-auto min-w-1/4 w-auto"
				:class="{
					'w-2/4': (size && size == 'md'),
					'w-10/12': (size && size == 'lg'),
					'w-11/12 max-w-6xl': (size && size == 'xl')
				}"
			>
				<!--content-->
				<div class="min-w-200 border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
					<!--header-->
					<div class="flex items-start justify-between p-5 border-b border-solid">
						<h3 class="page-title">
							{{ title }}
						</h3>
						<button class="bg-transparent hover:border-gray-200" @click="toggleModal()">
							<span class="text-gray-800 h-6 w-6 text-2xl block outline-none focus:outline-none">×</span>
						</button>
					</div>
					<!--body-->
					<div class="relative p-6">
						<slot name="body">
							
						</slot>
					</div>
					<!--footer-->
					<div class="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b gap-x-4">
						<slot name="footer">
				
						</slot>
					</div>
				</div>
			</div>
			</div>
		</div>
		<div v-if="showModal" class="opacity-25 fixed inset-0 z-40 bg-black"></div>
	</div>
</template>

<script>
import { onBeforeUnmount, ref, watch } from 'vue';

export default {
    name: 'Modal',
	emits: ['modalStatus'],
	props: {
		triggerText: String,
		buttonType: String,
		title: String,
		size: String,
		hide: {
			type: Boolean,
			default: false
		}
	},
    setup(props, context) {
        let showModal = ref(false);
        const originalBodyOverflow = document.body.style.overflow;

        function toggleModal() {
            showModal.value = !showModal.value;
			context.emit('modalStatus', showModal.value ? true : false);
        }

		function setModalStatus(status) {
			if (status === 'open') showModal.value = true;
			if (status === 'close') showModal.value = false;

			context.emit('modalStatus', showModal.value ? true : false);
		}

        watch(showModal, value => {
            document.body.style.overflow = value ? 'hidden' : originalBodyOverflow;
        });

        onBeforeUnmount(() => {
            document.body.style.overflow = originalBodyOverflow;
        });

        return { toggleModal, showModal, setModalStatus };
    }
}
</script>
